import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 p-4" }
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_3 = { class: "flex gap-2 items-center" }
const _hoisted_4 = { class: "text-gray-800 text-base font-semibold leading-6" }
const _hoisted_5 = {
  key: 0,
  class: "text-green-800 text-base px-2 py-1 bg-green-50 rounded-md font-semibold leading-6"
}
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "min-w-full border border-gray-300" }
const _hoisted_8 = { class: "px-4 py-2 text-gray-900 text-sm font-medium leading-5 border-b" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "text-gray-500 text-xs font-normal leading-4" }
const _hoisted_11 = { class: "px-4 py-2 text-gray-500 text-sm font-normal leading-5 border-b" }
const _hoisted_12 = { class: "px-4 py-2 text-gray-500 text-sm font-normal leading-5 border-b" }
const _hoisted_13 = { class: "px-4 py-2 text-gray-500 text-sm font-normal leading-5 border-b" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "px-4 py-2 border-b flex flex-row gap-4" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "flex justify-center w-full"
}
const _hoisted_24 = {
  key: 2,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_25 = { class: "bg-white rounded-lg p-6 max-w-md w-full mx-4" }
const _hoisted_26 = { class: "flex items-center justify-between mb-4" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "mb-4" }
const _hoisted_30 = { class: "bg-gray-50 rounded-md p-3" }
const _hoisted_31 = { class: "mb-2" }
const _hoisted_32 = { class: "ml-2 text-gray-700" }
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = { class: "ml-2 text-gray-700" }
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = { class: "ml-2 text-gray-700" }
const _hoisted_37 = { class: "mb-2" }
const _hoisted_38 = { class: "ml-2 text-gray-700" }
const _hoisted_39 = { class: "ml-2 text-gray-700" }
const _hoisted_40 = { class: "flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoadingSuggestedExperts || _ctx.isSendingInvite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary-purple" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, " Suggested Experts (" + _toDisplayString(_ctx.suggestedExperts.length) + "/" + _toDisplayString(_ctx.totalSuggestedExperts) + ") ", 1),
      (_ctx.sentSuccessfully)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Invite sent "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "bg-gray-150" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider uppercase leading-4" }, " Name "),
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider uppercase leading-4" }, " Title "),
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider uppercase leading-4" }, " Company "),
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider uppercase leading-4" }, " Source "),
            _createElementVNode("th", { class: "px-4 py-2 text-left text-gray-500 text-xs font-medium tracking-wider uppercase leading-4" }, " Action ")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestedExperts, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: "hover:bg-gray-50 text-left"
            }, [
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createTextVNode(_toDisplayString(row.fullName) + " ", 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(row.email), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_11, _toDisplayString(row.title), 1),
              _createElementVNode("td", _hoisted_12, _toDisplayString(row.organizationName), 1),
              _createElementVNode("td", _hoisted_13, [
                (row.source === 'Hubspot Contact' && row.contactUrl)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createElementVNode("a", {
                        href: row.contactUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "inline-flex items-center gap-1"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(row.source), 1),
                        _createElementVNode("span", {
                          class: "w-4 h-4 inline-block align-middle",
                          innerHTML: _ctx.HUBSPOT_LOGO_ICON
                        }, null, 8, _hoisted_16)
                      ], 8, _hoisted_15)
                    ]))
                  : (
                  row.source === 'Salesforce Contact' && row.contactUrl
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        _createElementVNode("a", {
                          href: row.contactUrl,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "inline-flex items-center gap-1"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(row.source), 1),
                          _createElementVNode("span", {
                            class: "w-8 h-8 inline-block align-middle",
                            innerHTML: _ctx.SALESFORCE_LOGO_ICON
                          }, null, 8, _hoisted_19)
                        ], 8, _hoisted_18)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(row.source), 1))
              ]),
              _createElementVNode("td", _hoisted_21, [
                _createVNode(_component_BaseButton, {
                  onClick: ($event: any) => (_ctx.handleInvite(index)),
                  disabled: _ctx.isSendingInvite,
                  class: "px-4 py-1 bg-indigo-100 text-primary-purple text-sm font-medium leading-5 border border-gray-300 rounded-md"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Invite ")
                  ])),
                  _: 2
                }, 1032, ["onClick", "disabled"]),
                _createVNode(_component_BaseButton, {
                  type: "button",
                  onClick: ($event: any) => (_ctx.handleRemove(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "w-4 h-4 flex items-center justify-center text-primary-purple",
                      innerHTML: _ctx.CROSS_IN_CIRCLE_ICON
                    }, null, 8, _hoisted_22)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.hasNextPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(_component_BaseButton, {
            onClick: _ctx.loadMoreSuggestions,
            disabled: _ctx.isSendingInvite,
            class: "px-6 py-2 rounded-md text-sm bg-primary-purple/10 text-primary-purple"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Load More")
            ])),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showRemoveConfirmation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900" }, " Remove Suggested Expert ", -1)),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.updateStatusLoading,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelRemove && _ctx.cancelRemove(...args))),
                class: "text-gray-400 hover:text-gray-600"
              }, [
                _createElementVNode("span", {
                  class: "w-5 h-5 flex items-center justify-center",
                  innerHTML: _ctx.CROSS_IN_CIRCLE_ICON
                }, null, 8, _hoisted_28)
              ], 8, _hoisted_27)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-gray-600 mb-3" }, " Are you sure you want to remove this suggested expert? ", -1)),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-medium text-gray-900" }, "Name:", -1)),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.expertToRemove?.fullName), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-medium text-gray-900" }, "Email:", -1)),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.expertToRemove?.email), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "font-medium text-gray-900" }, "Title:", -1)),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.expertToRemove?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-medium text-gray-900" }, "Company:", -1)),
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.expertToRemove?.organizationName), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-medium text-gray-900" }, "Source:", -1)),
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.expertToRemove?.source), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_BaseButton, {
                disabled: _ctx.updateStatusLoading,
                onClick: _ctx.cancelRemove,
                class: "px-4 py-2 text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode(" Cancel ")
                ])),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_BaseButton, {
                onClick: _ctx.confirmRemove,
                disabled: _ctx.updateStatusLoading,
                class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.updateStatusLoading ? "Removing..." : "Remove"), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}